<template>
  <div class="modal filter-modal promt-create-modal offer-modal accept-offer">
    <div class="overlay" @click="$emit('close')"></div>
    <div class="wrapper">
      <div class="container">
        <div>
          <div class="form-wrapper">
            <div class="form-fields">
              <div class="modal-head">
                <img class="close" @click="$emit('close')" src="./../images/close.svg"/>
                <div class="title">{{ $t('Payment detail') }}</div>
              </div>
              <div class="bottom">
                <div class="desc">
                  {{ $t('Please enter your bank details to accept payment') }}
                </div>
                <div class="input-container">
                  <div class="desc">{{ $t('Bank account number') }}:</div>
                  <input type="text" v-model="iban"/>
                </div>
                <div class="input-container">
                  <div class="desc">{{ $t('Full name') }}:</div>
                  <input type="text" v-model="full_name"/>
                </div>
              </div>
              <transition name="slide">
                <div v-if="error || localError" class="error-desc desc red">{{ localError || error }}</div>
              </transition>
              <div class="buttons">
                <button class="button blue" @click="confirm">
                  <span>[ {{ $t('CONFIRM') }} ]</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PaymentSepaModal",
  props: {
    error: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      full_name: "",
      iban: "",
      terms: false,
      localError: "",
    };
  },
  computed: {
    isFullNameTwoWords() {
      const parts = String(this.full_name || "").trim().split(/\s+/).filter(Boolean);
      return parts.length >= 2;
    },
    requiredFieldsAreFilled() {
      return this.isFullNameTwoWords && this.iban;
    },
  },
  methods: {
    goToTerms() {
      this.$emit('goToTerms');
    },
    goToPrivacy() {
      this.$emit('goToPrivacy');
    },
    confirm() {
      console.log('confirm');

      this.localError = "";
      if (!this.requiredFieldsAreFilled) {
        if (!this.isFullNameTwoWords) {
          this.localError = this.$t("Please enter your full name (at least two words)");
        }
        return;
      }

      this.$emit("confirm", {
        full_name: this.full_name,
        iban: this.iban,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.desc {
  font-size: 18px;
  font-weight: 700;
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>
